import { CultureInfo } from '../culture-info.model';
import { CultureInfoEn } from './en';

/**
 * @ignore
 */
export const CultureInfoEnSI: CultureInfo = {
  name: 'en-SI',
  displayName: 'English (Slovenia)',
  iso3LanguageCode: 'eng',
  iso2LanguageCode: 'en',
  ietfLanguageTag: 'en-SI',
  parent: CultureInfoEn
};
